var math = Math;
export var min = math.min;
export var max = math.max;
export function minMax(val, minVal, maxVal) {
    return min(max(minVal, val), maxVal);
}
